{
  "assistant": {
    "title": "Assistant"
  },
  "row": {
    "untitled": "Untitled",
    "rev": "Rev {{rev}}",
    "measured": "{{measured}} of {{total}} measured",
    "due": "due"
  },
  "event": {
    "someone": "Someone",
    "inspection": "inspection",
    "viaAssistant": "via assistant",
    "viaImport": "via import",
    "commented": "commented"
  },
  "chart": {
    "accepted": "Accepted",
    "rejected": "Rejected",
    "acceptedLc": "accepted",
    "rejectedLc": "rejected",
    "weekOf": "Week of",
    "weekOfLabel": "Week of {{week}}",
    "total": "Total",
    "aria": "FAIs closed per week, last 8 weeks",
    "colAria": "Week of {{week}}: {{accepted}} accepted, {{rejected}} rejected",
    "empty": "No FAIs closed in the last 8 weeks.",
    "showChart": "Show chart",
    "showTable": "Show as table"
  },
  "demo": {
    "sample": "Try the sample part",
    "workspace": "Load demo workspace",
    "loading": "Loading"
  },
  "bulk": {
    "title_one": "Export {{count}} FAI",
    "title_other": "Export {{count}} FAIs",
    "sub": "One zip, with a folder per FAI.",
    "downloadZip": "Download zip",
    "template": "Customer template",
    "none": "None",
    "templateHint": "Adds the filled Excel template to every folder",
    "slow": "PDFs are built in your browser, so a big export takes a minute.",
    "done_one": "Downloaded {{count}} FAI.",
    "done_other": "Downloaded {{count}} FAIs.",
    "doneSkipped": "Downloaded. Skipped: {{list}} (drawing not available).",
    "failed": "Could not build the export.",
    "skippedDrawing": "{{fai}} drawing",
    "progress": {
      "starting": "Starting",
      "server": "Building the Excel and data files",
      "pdfs": "Building PDFs: {{n}} of {{total}}",
      "zipping": "Zipping"
    },
    "formats": {
      "as9102Pdf": {
        "label": "AS9102 report (PDF)",
        "hint": "Forms 1 to 3, NCRs, signatures and the ballooned drawing"
      },
      "as9102Xlsx": {
        "label": "AS9102 Excel",
        "hint": "Forms 1 to 3 as a workbook"
      },
      "form3Csv": {
        "label": "Form 3 (CSV)",
        "hint": "One row per characteristic and piece"
      },
      "drawingPdf": {
        "label": "Ballooned drawing (PDF)",
        "hint": "Drawing sheets with balloons only"
      },
      "qif": {
        "label": "QIF 3.0 (XML)",
        "hint": "Plan and results for CMM software and portals"
      },
      "netInspectCsv": {
        "label": "Net-Inspect (CSV)",
        "hint": "AS9102 Form 3 import"
      },
      "ppapXlsx": {
        "label": "PPAP Excel",
        "hint": "Warrant, dimensional and material results"
      },
      "controlPlanXlsx": {
        "label": "Control plan Excel",
        "hint": "AIAG control plan"
      },
      "dataSheetXlsx": {
        "label": "Inspection data sheet Excel",
        "hint": "Blank check sheet"
      },
      "json": {
        "label": "JSON snapshot",
        "hint": "Everything, with the content hash"
      }
    }
  },
  "defaults": {
    "units": "Units",
    "shopDefault": "Shop default",
    "mm": "Millimetres",
    "in": "Inches",
    "sampling": "Sampling plan",
    "none": "None",
    "level": "Inspection level",
    "pieces": "Pieces",
    "reportTemplate": "Report template",
    "reportTemplatePh": "e.g. Customer FAI form",
    "generalTol": "General tolerance (leave empty to use the shop's)",
    "places": "Places",
    "tolAria": "{{unit}} tolerance for {{place}}"
  }
}
